import { type ReactNode } from 'react';
import DynamicDialog, { type DynamicDialogProps } from '@discover-components/ui/dynamicDialog';
import OptionList, { type Option } from './optionList';

export type MultiSelectComboBoxProps = {
  options: Option[];
  placeholder: string;
  description: string;
  setValue: (value: string | undefined) => void;
  isSelected: (value: string) => boolean;
  label: string;
  className?: string;
  children?: ReactNode;
} & Omit<DynamicDialogProps, 'triggerLabel' | 'dialogTitle' | 'dialogDescription' | 'children'>;

export default function MultiSelectComboBox({
  options,
  placeholder,
  description,
  setValue,
  isSelected,
  label,
  className,
  children,
  triggerProps,
  ...props
}: MultiSelectComboBoxProps) {
  return (
    <DynamicDialog
      triggerLabel={label}
      triggerProps={{
        children,
        className,
        ...triggerProps,
      }}
      dialogTitle={placeholder}
      dialogDescription={description}
      {...props}>
      {({ setOpen }) => (
        <OptionList
          options={options}
          setOpen={setOpen}
          setValue={setValue}
          isSelected={isSelected}
          placeholder={placeholder}
          multiple
        />
      )}
    </DynamicDialog>
  );
}
